import React, { Fragment } from 'react'
import { useMedia } from 'sb-hooks'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import { WidthContainer } from 'components/_new/layout/widthContainer'

import s from './Header.scss'
import messages from './messages'

import birdImage from './images/bird.svg'


const Header = () => {
  const { isMobile } = useMedia()

  return (
    <Fragment>
      <Box className={s.header} alignCenter={!isMobile}>
        <WidthContainer className={s.container}>
          {
            isMobile && (
              <div className={s.icon}>
                <img src={birdImage} alt="" />
              </div>
            )
          }
          <Text className={s.text} message={messages.title} size="20-24" html />
        </WidthContainer>
      </Box>
      <div className={s.fakeHeader} />
    </Fragment>
  )
}


export default Header
